import React, { useCallback, useMemo, useState } from 'react'

import Button from 'components/Button'
import TeleportPrimaryIcon from 'components/TeleportPrimaryIcon'
import { getStyles } from 'pages/admin/ForYouProfiles/styles'
import EventPreferencesModal from 'components/EventPreferencesModal'

const EmptyState = ({ onReload, admin, md }) => {
  const [isPreferenceOpen, setIsPreferenceOpen] = useState(false)
  const styles = useMemo(() => getStyles(md), [md])

  const handlePreferenceClose = useCallback(
    saved => {
      setIsPreferenceOpen(false)

      if (saved) {
        onReload()
      }
    },
    [onReload]
  )

  return (
    <div
      className="w-full bg-woodsmokeBlack2 flex flex-col justify-center items-center rounded-md text-white text-center md:rounded-2xl"
      style={styles.imageGallery}
    >
      <TeleportPrimaryIcon
        className="w-12 h-12 mb-10 hidden md:mt-0 md:w-14 md:h-14 md:block"
        style={{ filter: 'drop-shadow(0px 0px 14.884px rgba(255, 255, 255, 0.6))' }}
      />
      <div className="text-2xl mb-20 font-ownersWide font-semibold">
        You've seen everyone {!admin && 'who fits your preferences'}
      </div>
      {!admin && (
        <Button
          className="bg-azureBlue mb-4 rounded-full px-10 text-base"
          onClick={() => setIsPreferenceOpen(true)}
        >
          Widen Preferences
        </Button>
      )}
      <Button className="text-base underline" onClick={onReload}>
        Review Skipped Profiles
      </Button>
      <EventPreferencesModal show={isPreferenceOpen} onClose={handlePreferenceClose} />
    </div>
  )
}

export default EmptyState
